import React from 'react'
import PropTypes from 'prop-types'
import Section, { ExpandedContent, SectionHeader } from './Section'
import pluralize from 'pluralize'
import ContractVehicles from './ContractVehicles'
import ContractVehiclesShape from './prop_shapes/contract_vehicles'

const ContractVehicleSection = ({ contractVehicles: { count, items }, editButton }) => {
  const calloutText = () => {
    if (count > 0) {
      return `${count} ${pluralize('Contract Vehicle', count).toUpperCase()}`
    } else {
      return ''
    }
  }

  return (
    <Section
      expandable
      idText='contract-vehicles'
      padded
    >
      <SectionHeader
        callout={calloutText()}
        idText='contract-vehicles'
        editButton={editButton}
      >
        Contract Vehicles
      </SectionHeader>

      <ExpandedContent>
        <ContractVehicles
          contractVehicles={items}
        />
      </ExpandedContent>
    </Section>
  )
}

ContractVehicleSection.propTypes = {
  contractVehicles: ContractVehiclesShape.isRequired,
  editButton: PropTypes.element
}

ContractVehicleSection.defaultProps = {
  contractVehicles: [],
  editButton: null
}

export default ContractVehicleSection
